<template>
  <div class="seloHeader" v-if="isSala && visualizarLogo">
    <div
      class="medalhas"
      :style="{ cursor: semAuth ? '' : 'pointer' }"
      @click="$router.push('/cidade')"
    >
      <img :src="medalUrls.bronze" />
      <img :src="medalUrls.prata" />
      <img :src="medalUrls.ouro" />
      <img :src="medalUrls.diamante" />
    </div>

    <div
      class="tituloSelo"
      :style="{ cursor: semAuth ? '' : 'pointer' }"
      @click="!semAuth && $router.push('/cidade')"
    >
      Selo Sebrae de Referência em Atendimento - 2026
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getAllMedalsUrlsSync } from "@/helpers/seloMedalhas.js";

export default {
  computed: {
    ...mapGetters(["isSala", "isFullAdmin", "groupsConfig", "config"]),
  },
  props: {
    semAuth: { type: Boolean },
  },
  watch: {
    groupsConfig: {
      handler(val, oldVal) {
        this.visualizarLogo =
          this.isFullAdmin ||
          (this.groupsConfig &&
            this.config &&
            this.groupsConfig.visualizarLogo &&
            this.config.visualizarLogo);
      },
      deep: true,
    },
  },
  data() {
    return {
      visualizarLogo: false,
      medalUrls: getAllMedalsUrlsSync(),
    };
  },
  mounted() {
    if (this.semAuth) this.visualizarLogo = true;
    else {
      this.visualizarLogo =
        this.isFullAdmin ||
        (this.groupsConfig &&
          this.config &&
          this.groupsConfig.visualizarLogo &&
          this.config.visualizarLogo);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/variables.scss";
.seloHeader {
  display: flex;
  align-items: center;
  column-gap: 5px;
}
.tituloSelo {
  color: #fff;
  font-weight: bold;
}
.medalhas {
  width: 50px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 2px;
  align-items: center;
  img {
    width: 20px;
  }
}
</style>
